'use strict';

import React from 'react';
import flux from 'utils/flux';
import videojs from 'video.js';
import videoJsResolutionSwitcher from 'videojs-resolution-switcher';
import { Link } from 'react-router';
import queryString from 'query-string';
import dom from 'utils/dom';
import api from 'utils/api';
import classnames from 'classnames';
import screenfull from 'screenfull';
import AltContainer from 'alt-container';
import BasketDropdown from 'components/basket/basketDropdown';
import MediaListingItemNotification from 'pages/media/mediaListingItemNotification';
import _cloneDeep from 'lodash/lang/cloneDeep';
import ImageViewer from 'components/imageViewer/imageViewer';
import HtmlViewer from 'components/htmlViewer/htmlViewer';
import ThumbnailViewer from 'components/thumbnailViewer/thumbnailViewer';

const MediaModal = React.createClass({

    displayName: 'MediaModal',

    propTypes: {
        media: React.PropTypes.object
    },


    contextTypes: {
        router: React.PropTypes.func.isRequired
    },

    getInitialState() {
        let tempArray = this.props.media.toJS().thumbnails.map(function (thumbnail) {
            let previewImage = thumbnail.preview;
            previewImage.hidden = "none";
            return previewImage;
        });
        tempArray[0].hidden = "block";
        return {
            autoResolution: true,
            videoPlayed: false,
            previewArray: tempArray,
            currentIndex: 0
        }
    },

    handleViewOrientation() {
        const modalMedia = document.querySelector('.modal__media');
        let orientation  = this.props.modalOrientation;


        if (typeof orientation === 'undefined') {
            orientation = 'default';
        }

        modalMedia.className = 'modal modal__media modal__media--' + orientation;
    },

    componentWillMount() {
    },

    componentDidMount() {
        this.handleViewOrientation();

        if ( 'video' === this.props.media.toJS().type ) {
            this.setupVideoPlayer();
        }
        else if ( Modernizr && !Modernizr.objectfit ) {
            // Polyfill object-fit: contain
            let image  = this.refs.preview.getDOMNode(),
                parent = image.parentNode;

            if ( !parent ) return;

            image.style.display = 'none';
            parent.style.backgroundImage = 'url(' + image.src + ')';
        }

        window.addEventListener( 'resize', this, false );
        document.addEventListener( 'fullscreenchange', this, false );
        document.addEventListener( 'mozfullscreenchange', this, false );
        document.addEventListener( 'webkitfullscreenchange', this, false );
        document.addEventListener( 'click', this, true );
        document.addEventListener("keydown", this.detectArrowPress, false);
        this.resize();
        if (('video' === this.props.media.toJS().type) &&  this.state.videoPlayed) {
            this.player.play();
        }

    },

    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
        window.removeEventListener( 'resize', this, false );
        document.removeEventListener( 'fullscreenchange', this, false );
        document.removeEventListener( 'mozfullscreenchange', this, false );
        document.removeEventListener( 'webkitfullscreenchange', this, false );
        document.removeEventListener( 'click', this, true );
        document.removeEventListener("keydown", this.detectArrowPress, false);
    },

    componentDidUpdate() {
        this.componentDidMount();
    },

    detectArrowPress(event){
        let metaData = this.props.mediaMeta.toJS();
        let media = this.props.media.toJS();
        // right arrow
        if(event.keyCode === 39) {
            if (this.showNextPageArrow(media, metaData)){
                this.switchToNextItem();
            }
        }
        // left arrow
        if(event.keyCode === 37) {
            if (this.showPreviousPageArrow(media, metaData)){
                this.switchToPreviousItem();
            }
        }
    },
    // {`${media.indexInResults+1+(metaData.page-1)*10} ${flux.t('pagination_of')} ${metaData.total_records}`}


    showNextPageArrow(media, metaData) {
        let current = (media.indexInResults+1+(metaData.page-1)*metaData.per_page);
        return ( current < metaData.total_records);
    },

    showPreviousPageArrow(media, metaData) {
        return !media.firstElementOfResults || (metaData.page !== 1);
    },

    showNextContentArrow(media, metaData) {
        const thumbnailImages = media.thumbnails;
        const previewImages = thumbnailImages.map(thumbnail => thumbnail.preview);
        const numImages = previewImages.length;
        if (numImages >= 2) {
            return true;
        }
        return false;
    },

    showPreviousContentArrow(media, metaData) {
        const thumbnailImages = media.thumbnails;
        const previewImages = thumbnailImages.map(thumbnail => thumbnail.preview);
        const numImages = previewImages.length;
        if (numImages >= 2) {
            return true;
        }
        return false;
    },

    handleEvent(e) {
        if ( 'resize' === e.type ) {
            window.requestAnimationFrame && window.requestAnimationFrame( this.resize );
            !window.requestAnimationFrame && this.resize();
        } else if (e.type.indexOf('fullscreenchange') > -1) {
            this.updateVideoResolution();
        } else if ('click' === e.type) {
            const {target, target: {className}} = e;
            if (className.indexOf('vjs-menu-item') > -1 && target.parentNode.parentNode.parentNode.className.indexOf('vjs-resolution-button') > -1) {
                this.setState({
                    autoResolution: false
                });
            }
        }
    },

    setupVideoPlayer() {
        let media        = this.props.media.toJS();
        let videoWrapper = document.createElement('VIDEO');
        let video        = this.refs.video.getDOMNode();

        video.innerHTML = '';
        if ( 'video' !== this.props.media.toJS().type ) {
            return;
        }

        dom.setAttributes( videoWrapper, {
            'class':  'video-js vjs-default-skin',
            controls: true,
            preload:  'auto',
            poster:   api.cachedImagePath( Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src )
        });

        const mapQualToLabel = quality => {
            switch ( quality ) {
                case 'full':
                    return {
                        label: 'HD',
                        res: 1080
                    };
                case 'low':
                    return {
                        label: 'SD',
                        res: 720
                    };
            }
            return {
                label: quality,
                res: null
            };
        };

        let sources = [];

        media.videos.forEach( video => {
            const quality = mapQualToLabel(video.quality);
            sources.push({
                src:    video.url,
                type:   video.mimeType,
                label:  quality.label,
                res:    quality.res
            });
        });

        video.appendChild( videoWrapper );

        this.player = videojs( videoWrapper, {
            sources,
            plugins: {
                videoJsResolutionSwitcher: {
                    'default': 'low'
                }
            }
        });
    },

    updateVideoResolution() {
        const { autoResolution } = this.state;

        if ( !autoResolution ) {
            return;
        }

        if ( screenfull.isFullscreen ) {
            this.player.currentResolution('HD');
        } else {
            this.player.currentResolution('SD');
        }
    },

    generateInstantDownload(e) {
        e.preventDefault();
        flux.getActions('modals').openInstantDownloadModal(this.props.media);
    },

    toggleCheck(e) {
        e.preventDefault();
        flux.getActions('media').toggleItemSelection( this.props.media.get('id') );
    },

    toggleBasketFix(e) {
        e.preventDefault();
        let id = this.props.media.get('id');
        let order = flux.getStore('media').getState().media.findIndex( item => item.get('id') === id );
        flux.getActions('modals').openMediaModal( flux.getStore('media').getState().media.get(order) );

        if (!this.props.media.get('_basket')) {
            flux.getActions('media').toggleBasket( id);
            flux.getActions('modals').openMediaModal( flux.getStore('media').getState().media.get(order) );
        }
    },

    renderBasket() {
        if (this.props.media.get('_basket') && flux.getStore('modals').getState().openModal) {
            let mediaId   = this.props.media.get('id');
            let mediaName = this.props.media.get('name') || this.props.media.get('title');
            return (
                <AltContainer
                    stores={{basketStore: flux.getStore('basket')}}
                    transform={({ basketStore }) => {
                        let baskets = basketStore.baskets;
                        const slotDefinitions = basketStore.slotDefinitions;
                        return {baskets, slotDefinitions};
                    }}>
                    <BasketDropdown mediaId={mediaId} mediaName={mediaName} media={this.props.media} isFooter={true} />
                </AltContainer>
            );
        }
    },

    componentWillReceiveProps(nextProps) {
        let tempArray = nextProps.media.toJS().thumbnails.map(function (thumbnail) {
            let previewImage = thumbnail.preview;
            previewImage.hidden = "none";
            return previewImage;
        });
        tempArray[0].hidden = "block";

        this.setState({
            videoPlayed: false,
            previewArray: tempArray,
            currentIndex: 0
        });
    },

    switchToNextItem() {
        if (this.props.media.toJS().lastElementOfResults) {
            let query = _cloneDeep(this.context.router.getCurrentQuery());
            query.page = flux.getStore('media').getState().modalMeta.toJS().page + 1;
            flux.getActions('media').fetchNextPage();
            flux.getStore('media').loadMediaModals(query);
        } else {
            flux.getActions('media').setNextElement(this.props.media.get('id'));
            let nextElement = flux.getStore('media').getState().nextElement;
            flux.getActions('modals').openMediaModal(nextElement);
            this.props.media = nextElement;
        }
    },

    switchToPreviousItem() {
        if (this.props.media.toJS().firstElementOfResults) {
            flux.getActions('media').fetchPreviousPage();
            let query = _cloneDeep(this.context.router.getCurrentQuery());
            query.page = flux.getStore('media').getState().modalMeta.toJS().page - 1;
            flux.getStore('media').loadMediaModals(query);
        } else {
            flux.getActions('media').setPreviousElement(this.props.media.get('id'));
            let previousElement = flux.getStore('media').getState().previousElement;
            flux.getActions('modals').openMediaModal(previousElement);
            this.props.media = previousElement;
        }
        let tempArray = this.props.media.toJS().thumbnails.map(function (thumbnail) {
            let previewImage = thumbnail.preview;
            previewImage.hidden = "none";
            return previewImage;
        });
        tempArray[0].hidden = "block";

        this.setState({
            videoPlayed: false,
            previewArray: tempArray,
            currentIndex: 0
        });


    },

    switchToPreviousImage(currentIdx) {
        let copiedPreviewArray = [...this.state.previewArray];
        if (currentIdx === 0) {
            // do nothing
        } else {
            copiedPreviewArray.map((value, index) => {
                if (index === currentIdx) {
                    this.setHidden(value)
                }
                if (index === currentIdx - 1) {
                    this.setVisible(value)
                }
            });
            this.setState({
                previewArray: copiedPreviewArray,
                currentIndex: currentIdx - 1
            });
        }
    },

    switchToNextImage(currentIdx) {
        let copiedPreviewArray = [...this.state.previewArray];
        if (currentIdx === copiedPreviewArray.length - 1) {
            // do nothing
        } else {
            copiedPreviewArray.map((value, index) => {
                if (index === currentIdx) {
                    this.setHidden(value)
                }
                if (index === currentIdx + 1) {
                    this.setVisible(value)
                }
            });
            this.setState({
                previewArray: copiedPreviewArray,
                currentIndex: currentIdx + 1
            });
        }
    },

    resize() {
        let previewImg = this.props.media.toJS().thumbnails[0].preview,
            previewImgRatio =
                ( this._cache && this._cache.previewImgRatio ) ||
                ( previewImg.width / previewImg.height ),
            desiredHeight,
            maxHeight;

        const { type } = this.props.media.toJS();

        // constants
        let MARGIN = 20,
            RATIO  = 16 / 9;

        if ( this._cache && window.innerHeight === this._cache.windowHeight ) {
            return;
        } else if (!this._cache) {
            this._cache = {
                descEl:    this.refs.description.getDOMNode(),
                previewEl:
                    this.refs.preview ?
                        this.refs.preview.getDOMNode().parentNode :
                        this.refs.video.getDOMNode().childNodes[0],
                contentEl: this.refs.modalInner.getDOMNode().parentNode,
                previewImgRatio: previewImgRatio
            }
        }
        this._cache.windowHeight      = window.innerHeight;
        this._cache.descriptionHeight = this._cache.descEl.offsetHeight;
        this._cache.previewWidth      = this._cache.previewEl.offsetWidth;

        if ( 'video' !== type && previewImgRatio < RATIO ) {
            // adjust container size
            desiredHeight = this._cache.previewWidth / previewImgRatio;
            maxHeight = this._cache.windowHeight - this._cache.descriptionHeight - ( MARGIN * 2 );
            this._cache.previewEl.style.paddingTop = ( Math.min( desiredHeight, maxHeight ) / this._cache.previewWidth * 100 ).toFixed(3) + '%';
        }

        // center vertically
        let marginTop = 'video' !== type ?
            Math.floor(
                Math.max(
                    MARGIN,
                    ( this._cache.windowHeight - this._cache.contentEl.offsetHeight ) / 2
                )
            ) :
            Math.floor(
                Math.max(
                    MARGIN,
                    ( this._cache.windowHeight - ( this._cache.contentEl.offsetWidth / RATIO + this._cache.descriptionHeight ) ) / 2
                )
            );
        this._cache.contentEl.style.marginTop = marginTop + 'px';
    },

    clickOnVideoModal() {
        let videoPlayed = this.state.videoPlayed;
        if (!videoPlayed) {
            this.setState({
                videoPlayed: !videoPlayed,
            });
        }
    },

    setHidden(thumbnail) {
        thumbnail.hidden = 'none';
    },

    setVisible(thumbnail) {
        thumbnail.hidden = 'block';
    },

    renderMediaViewer() {
        return (this.state.previewArray.map((value, index) => {

            return <div className="thumbnail__div" id={index} style={{display: value.hidden}}>
                <div className="arrow-wrapper-document-viewer">
                    <button hidden={index === 0} onClick={() => this.switchToPreviousImage(index)}
                            className="actions__switch-previous"
                            title={flux.t('pagination_back')} >
                        <div className="switch__button">
                            <i className="chevron-left"/>
                        </div>
                    </button>
                    <button hidden={index === this.state.previewArray.length - 1}
                            onClick={() => this.switchToNextImage(index)} className="actions__switch-next"
                            title={flux.t('pagination_next')} >
                        <div className="switch__button">
                            <i className="chevron-right"/>
                        </div>
                    </button>
                </div>
                     <ImageViewer src={value.src} width={value.width} height={value.height} multipleThumbnails={this.state.previewArray.length > 1} ref="preview" />
            </div>
        }));
    },

    renderMediaPreview() {
        let media = this.props.media.toJS();
        let mediaType = media.type;
        const {archiveColor, embargoColor} = flux.getStore('app').getState().config.toJS();
        return (
            <div className={classnames('media__image', 'media__image--type__' + mediaType)} ref="mediaImageContainer">
                {'video' === mediaType &&
                <div ref="video" className={`item__preview__overlay ${this.state.videoPlayed}`}
                     onClick={this.clickOnVideoModal}/>}
                {media.embargo &&
                <div className="item__preview__overlay" style={{border: `5px solid ${embargoColor}`}}/>}
                {media.archived &&
                <div className="item__preview__overlay" style={{border: `5px solid ${archiveColor}`}}/>}
                {(() => {
                    if ('video' !== mediaType && this.state.previewArray) {
                        const numImages = this.state.previewArray.length;
                        if (numImages === 1) {
                            if (this.state.previewArray[0].src.includes('/text-preview/')) {
                                return (<HtmlViewer url={this.state.previewArray[0].src} ref="preview" />);
                            }
                            return (
                                <ImageViewer src={this.state.previewArray[0].src} width={this.state.previewArray[0].width} height={this.state.previewArray[0].height} multipleThumbnails={this.state.previewArray.length > 1} ref="preview" />
                            );
                        }
                        if (numImages >= 2) {
                            return (
                                <div className="preview__list">
                                    {this.renderMediaViewer()}
                                </div>
                            );
                        }
                    }
                })()}
                {media.thumbnails.length > 1 ? <ThumbnailViewer
                                                                        thumbnails={media.thumbnails}
                                                                        currentIndex={this.state.currentIndex}
                                                                        goToFirstImage={this.goToFirstImage}
                                                                        goToPreviousImage={this.goToPreviousImage}
                                                                        goToNextImage={this.goToNextImage}
                                                                        goToLastImage={this.goToLastImage}
                                                                        goToIndex={this.goToIndex} />
                : ""}
            </div>
        );
    },

    goToFirstImage: function () {
        let copiedPreviewArray = [...this.state.previewArray];
        copiedPreviewArray.map((value, index) => {
            if (index === 0) {
                value.hidden = 'block';
            } else {
                value.hidden = 'none';
            }
        });
        this.setState({
            previewArray: copiedPreviewArray,
            currentIndex: 0
        });
    },

    goToPreviousImage: function () {
        this.switchToPreviousImage(this.state.currentIndex);
    },

    goToNextImage: function () {
        this.switchToNextImage(this.state.currentIndex);
    },

    goToIndex: function (index, e) {
        e.preventDefault();
        let copiedPreviewArray = [...this.state.previewArray];
        copiedPreviewArray.map((value, idx) => {
            if (idx === index) {
                value.hidden = 'block';
            } else {
                value.hidden = 'none';
            }
        });
        this.setState({
            previewArray: copiedPreviewArray,
            currentIndex: index
        });
    },

    goToLastImage: function () {
        let copiedPreviewArray = [...this.state.previewArray];
        copiedPreviewArray.map((value, index) => {
            if (index === copiedPreviewArray.length-1) {
                value.hidden = 'block';
            } else {
                value.hidden = 'none';
            }
        });
        this.setState({
            previewArray: copiedPreviewArray,
            currentIndex: this.state.previewArray.length - 1
        });
    },

    renderTags() {
        return (
            <div className="description__tags">
                {this.props.media.toJS().tags.map((tag, ix) => {
                    return (
                        <Link key={'tag_' + ix} onClick={flux.getActions('modals').closeModals} to="listing"
                              className={`btn btn-small btn-primary tags__button`}
                              query={queryString.parse(tag.link)}>{tag.name}</Link>
                    );
                })}
            </div>
        );
    },

    shareItem() {
        // Dont want to duplicate Share modal, so we use already existing store to set up shareurl
        flux.getStore('basket').setShareUrl(window.location.origin + '/#/media?search=' + this.props.media.toJS().id);
        flux.getActions('modals').setModalInModal(this.props.media.toJS().id);
        flux.getActions('modals').openModal('Share');
    },

    renderSlots() {
        const slotDefinitions = this.props.slotDefinitions.toJS();

        const slotConfig = this.props.slotConfig;
        return (
            <div className="description__slots">
                {slotConfig.slice(2).map(slot => {
                    const id = slot.toString();
                    const currentSlotDefinition = slotDefinitions.filter(slot => slot.id === id);
                    const currentSlot = this.props.media.toJS().slots.filter(slot => slot.id === id);

                    if (currentSlot[0] && (currentSlot[0].content || currentSlot[0].color || currentSlot[0].icon) && currentSlotDefinition[0]) {
                        return (
                            <div className="description__item">
                                <p className="description__item--title">{currentSlotDefinition[0].name}</p>
                                {this.renderSlotProperties(currentSlot[0])}
                            </div>
                        );
                    }
                })}
            </div>
        );
    },

    renderSlotProperties(slot) {
        return (
            <div className="slot">
                {Object.keys(slot).map(function (key) {
                    switch (key) {
                        case 'content':
                            return <span key={key}
                                         className={`slot-property slot-property__${key}`}> {slot[key]}</span>;
                        case 'color':
                            return <span key={key} className={`slot-property slot-property__${key}`}
                                         style={{backgroundColor: slot[key]}}></span>;
                        case 'icon':
                            return <span key={key} className={`slot-property slot-property__${key}`}><img
                                src={slot[key]}/></span>;
                        default:
                            return null;
                    }
                })}
            </div>
        );
    },

    render() {
        if (!this.props.media || !this.props.media.toJS()) {
            return;
        }

        let media = this.props.media.toJS();
        let metaData = this.props.mediaMeta.toJS();
        const slotConfig = this.props.slotConfig;
        const isAuthenticated = flux.getStore('app').isAuthenticated();
        let title = media.slots.filter(slot => slot.id === slotConfig[0].toString());
        let description = media.slots.filter(slot => slot.id === slotConfig[1].toString());
        const { shareMode } = flux.getStore('app').getState().config.toJS();

        return (
                <div  ref="modalInner" className="modal__flex__wrapper">
                    <AltContainer
                        stores={{notificationsStore: flux.getStore('notifications')}}
                        transform={({notificationsStore}) => {
                            let notifications = notificationsStore.notifications
                                .filter((notification) => notification.mediaId === media.id);
                            return {notifications};
                        }}>
                        <MediaListingItemNotification/>
                    </AltContainer>
                    {this.renderMediaPreview()}

                    <div className="media__wrapper">
                        <div className="media__description" ref="description">
                            <div className="description__info">
                                {(title[0] && title[0].content && slotConfig[0]) &&
                                <div className="description__item">
                                    <h4 title={title[0].content}>{title[0].content}</h4>
                                </div>
                                }
                                {(description[0] && description[0].content && slotConfig[1]) &&
                                <div className="description__item">
                                    <p className="description__item--content">{description[0].content}</p>
                                </div>
                                }
                                {this.renderSlots()}
                                {
                                    isAuthenticated && (this.props.media.toJS().tags && this.props.media.toJS().tags.length > 0) &&
                                    <div className="description__item">
                                        <p className="description__item--title">Tags</p>
                                        <p className="description__item--content">{this.renderTags(this.colors)}</p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="media__navigation__bar">
                        {this.showPreviousPageArrow(media, metaData) ? (
                            <button onClick={this.switchToPreviousItem}
                                    className="actions__switch-previous actions__switch media__navigation__bar__button" title={flux.t('pagination_back')}>
                                <div className="switch__button">
                                    <i className="circle-chevron-left"/>
                                </div>
                            </button>
                        ) : <button disabled={true} style={{visibility:'hidden'}} className="actions__switch-previous actions__switch media__navigation__bar__button" title={flux.t('pagination_back')}>
                            <div className="switch__button">
                                <i className="circle-chevron-left"/>
                            </div>
                        </button>}
                        <div className="page_number">
                            {`${media.indexInResults+1+(metaData.page-1)*metaData.per_page} ${flux.t('pagination_of')} ${metaData.total_records}`}
                        </div>
                        {this.showNextPageArrow(media, metaData) ? (
                            <button onClick={this.switchToNextItem} className="actions__switch-next actions__switch media__navigation__bar__button" title={flux.t('pagination_next')}>
                                <div className="switch__button">
                                    <i className="circle-chevron-right"/>
                                </div>
                            </button>
                        ) : <button disabled={true} style={{visibility:'hidden'}} className="actions__switch-next actions__switch media__navigation__bar__button"  title={flux.t('pagination_next')}>
                            <div className="switch__button">
                                <i className="circle-chevron-right"/>
                            </div>
                        </button>}

                        {(shareMode === 'auth') &&
                        <button onClick={this.shareItem} className="icn actions__share_item media__button media__navigation__bar__button">
                            <div className="icn-holder share_item__button">
                                <i className="share"/>
                            </div>
                        </button>
                        }
                        {('auth' === shareMode || 'openDownload' === shareMode) &&
                        <div onClick={this.generateInstantDownload} className="icn actions__directdownload media__button media__navigation__bar__button">
                            <div className="icn-holder directdownload__button">
                                <i className="download"/>
                            </div>
                        </div>}
                        {('auth' === shareMode || 'openDownload' === shareMode) &&
                        <div onClick={this.toggleBasketFix} className="icn actions__addtobasket media__button media__navigation__bar__button">
                            <div className="icn-holder addtobasket__button">
                                <i className="plus-small"/>
                            </div>
                        </div>}
                        {this.renderBasket()}
                    </div>
                </div>

        );
    }
});

module.exports = MediaModal;



// WEBPACK FOOTER //
// ./app/components/modals/mediaModal.jsx